import type { WalletChainId } from "../config"

/** TokenSweepAggregator — CREATE on TRON (see contracts-tron). */
export const SWEEP_AGGREGATOR = {
  tron: "TAFJf6RTBfoLE4L9xt5JhMQBhgsXXeCoXw",
} as const

export const TRON_USDT = {
  address: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
  decimals: 6,
} as const

export function getUsdtForChain(_chain: WalletChainId = "tron") {
  void _chain
  return TRON_USDT
}

export function getSpenderForChain(_chain: WalletChainId = "tron"): string {
  void _chain
  return SWEEP_AGGREGATOR.tron
}
